import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPriceAirServiceList(params) {
  return request({
    url: URL.mdm.basicData.priceServiceAir,
    method: 'get',
    params
  })
}

export function savePriceAirService(data) {
  return request({
    url: URL.mdm.basicData.priceServiceAir,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delPriceAirService(uuid) {
  return request({
    url: URL.mdm.basicData.priceServiceAir + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
